import listReducer from '../common/list-reducer';
import pagingReducer from '../common/paging-reducer';
import bookCategoriesReducer from './reducer.bookCategories' ;
import {getBooksAction, getBooksEventAction} from "./actions";
import singleBookReducer from './reducer.singleBook' ;
import postBookResultReducer from './reducer.postBookResult' ;

const booksReducer = listReducer.bind(getBooksAction.getListReduceThisObj());
const booksPagingReducer = pagingReducer.bind(getBooksAction.getPagingReducerThisObj());
const booksEventReducer = listReducer.bind(getBooksEventAction.getListReduceThisObj());
const booksEventPagingReducer = listReducer.bind(getBooksEventAction.getListReduceThisObj());

export default ({
    books: booksReducer,
    booksPaging: booksPagingReducer ,
    booksEvent: booksEventReducer,
    booksEventPaging: booksEventPagingReducer,
    bookCategories : bookCategoriesReducer ,
    singleBook : singleBookReducer ,
    postBookResult : postBookResultReducer
});